import React from 'react'
import { Container, Title, Header } from './style'
import {
    Benefits,
    Content,
    Item,
    ItemDesc,
    ItemTitle,
    List
} from './ProductPodFullExperience.style'
import {
    fullExperiencePodData,
    benefitsIcons
} from 'pages/DetailProduct/data/full-experience'

const ProductPodFullExperience = () => {
    return (
        <Container>
            <Header>
                <Title>Um mundo de benefícios para todos os momentos</Title>
            </Header>
            <Content>
                <Benefits>
                    {benefitsIcons.map((benefit) => (
                        <div key={benefit}>
                            <img src={benefit} alt="Benefício" />
                        </div>
                    ))}
                </Benefits>
                <List>
                    {fullExperiencePodData.map((exp) => (
                        <Item key={exp.title}>
                            {exp.title && (
                                <ItemTitle
                                    $color={exp.color}
                                    $bgColor={exp.color}
                                >
                                    {exp.title}
                                </ItemTitle>
                            )}
                            {exp.desc && <ItemDesc>{exp.desc}</ItemDesc>}
                        </Item>
                    ))}
                </List>
            </Content>
        </Container>
    )
}

export default ProductPodFullExperience
